import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=959199fc"
import script from "./project-information.ts?vue&type=script&lang=ts&external"
export * from "./project-information.ts?vue&type=script&lang=ts&external"
import style0 from "./project-information.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports